(function (d, t) {
  var bh = d.createElement(t), s = d.getElementsByTagName(t)[0];
  bh.type = 'text/javascript';
  bh.src = 'https://www.bugherd.com/sidebarv2.js?apikey=ihj84wtxymfctbuyl3hsxw';
  s.parentNode.insertBefore(bh, s);
  })(document, 'script');

